module.exports = __webpack_public_path__ + "components/switch-units/static/preferences-4ab6a228fc74ddf01f8c2ee259e68e5e.svg";